import { render, staticRenderFns } from "./ProductSummary.vue?vue&type=template&id=774b92e0&scoped=true&"
import script from "./ProductSummary.vue?vue&type=script&lang=ts&"
export * from "./ProductSummary.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSummary.vue?vue&type=style&index=0&id=774b92e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774b92e0",
  null
  
)

export default component.exports